import React from 'react';
import { MailIcon } from 'lucide-react';
import { PRODUCT, SUPPORT_EMAIL } from '../data/woodworking';
export function Footer() {
  return <footer id="site-footer" className="border-t border-white/10 bg-charcoal-deep py-12 text-white" data-id="element-42" data-mp="3ggk72reij5xy">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-43" data-mp="32pp764lzrz6i">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between" data-id="element-44" data-mp="36ooaxlvzlpwd">
          <div data-id="element-45" data-mp="3uesb1j9yv7im">
            <p className="wordmark text-[1.1rem] text-ivory sm:text-[1.25rem]" data-id="element-46" data-mp="3ug3c3bc12161">
              Woodworking Furniture Plans<sup className="ml-0.5 font-sans text-[0.5em] font-semibold" data-id="element-47" data-mp="37fpks21w7ww">™</sup>
            </p>
            <p className="mt-2 text-[0.92rem] text-muted" data-id="element-48" data-mp="3ldkeb5n3meqn">{PRODUCT.descriptor}</p>
          </div>

          <div data-id="element-49" data-mp="3qc3zv4xs5oih">
            <p className="label-tech text-muted" data-id="element-50" data-mp="3qblwzpgm4c1l">Support</p>
            <a href={`mailto:${SUPPORT_EMAIL}`} className="mt-1 inline-flex min-h-[44px] items-center gap-2 text-[0.92rem] text-parchment transition-colors duration-150 ease-out hover:text-olive-light focus:outline-none focus-visible:text-olive-light" data-id="element-51" data-mp="29yxcxcohlklt">
              <MailIcon className="h-4 w-4 shrink-0 text-olive-light" aria-hidden data-id="element-52" data-mp="3gb8vj0znlauj" />
              <span className="break-all" data-id="element-53" data-mp="3v7ggi3ivygav">{SUPPORT_EMAIL}</span>
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-1.5 border-t border-white/10 pt-6 text-[0.82rem] text-muted sm:flex-row sm:flex-wrap sm:gap-x-4" data-id="element-54" data-mp="3q83rbc4jkx54">
          <p data-id="element-55" data-mp="817c224r7iry">© 2026 WOODWORKING FURNITURE PLANS™. All rights reserved.</p>
          <p data-id="element-56" data-mp="32w45wy0ricd">Commercial build rights included. Digital files may not be shared or resold.</p>
        </div>
      </div>
    </footer>;
}